const HsrHeader = props => {
    return (
        <div>
            <h1>Header</h1>
        </div>
    );
};

export default HsrHeader;
